var JhiMissingTranslationHandler = /** @class */ (function () {
    function JhiMissingTranslationHandler(configService) {
        this.configService = configService;
    }
    JhiMissingTranslationHandler.prototype.handle = function (params) {
        var key = params.key;
        return this.configService.getConfig().noi18nMessage + "[" + key + "]";
    };
    return JhiMissingTranslationHandler;
}());
export { JhiMissingTranslationHandler };



//////////////////
// WEBPACK FOOTER
// ./~/ng-jhipster/src/language/jhi-missing-translation.config.js
// module id = 1741
// module chunks = 1